export default __webpack_public_path__ + "static/media/canada.0a49ef1f.png";